// api.js — accesso dati e costanti del Cruscotto v3 (F2.3, primo mattone React).
// PARITÀ B3a: STESSE chiamate REST del v1 (dashboard-module.js:19-30), stesso
// token, stessa base, stesso error handling (errore SEMPRE visibile, mai
// silenzioso). STESSE costanti semantiche (SRC_META/ACT_ICON/URG_GROUPS/KPI):
// la parità voce-per-voce col sorgente v1 è asserita dal contract test
// server/src/lib/dash-v3-register.test.js (stile B2.12: si legge l'artefatto).
// File PURO (niente JSX, niente side-effect): importabile da node --test.

export const TOKEN_KEY = 'crm_token';

export function getBase(win) { return (win.PROC_CRM_API_BASE || '/api'); }

export function getToken(win) {
  try { return win.localStorage.getItem(TOKEN_KEY); } catch (e) { return null; }
}

// REST helper — semantica IDENTICA al v1: json best-effort, !ok ⇒ throw con
// l'errore del server o 'Errore <status>'.
export async function api(win, path, opts) {
  opts = opts || {};
  const headers = { 'Content-Type': 'application/json' };
  const t = getToken(win);
  if (t) headers['Authorization'] = 'Bearer ' + t;
  const r = await win.fetch(getBase(win) + '/dash' + path, {
    method: opts.method || 'GET',
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  let data = null;
  try { data = await r.json(); } catch (e) { /* body non-JSON: resta null */ }
  if (!r.ok) throw new Error((data && data.error) || ('Errore ' + r.status));
  return data;
}

// --- util data (copie 1:1 del v1) ---
export function todayISO() { return new Date().toISOString().slice(0, 10); }

export function fmtDay(iso) {
  if (!iso) return '—';
  const p = String(iso).slice(0, 10).split('-');
  return p[2] + '/' + p[1] + '/' + p[0];
}

// from/to del mese visualizzato — stessa matematica di loadAll v1 (dashboard-module.js:174-176)
export function monthRange(year, month) {
  const mm = String(month + 1).padStart(2, '0');
  const lastDay = new Date(year, month + 1, 0).getDate();
  return {
    from: year + '-' + mm + '-01',
    to: year + '-' + mm + '-' + String(lastDay).padStart(2, '0'),
  };
}

export const MONTHS = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

// Palette FONTI agenda: colori SEMANTICI dei dati (dot calendario + badge +
// legenda) — restano letterali, NON token chrome (parità visiva dei dati col v1).
export const SRC_META = {
  task: { label: 'Task', color: '#6366f1' },
  amm: { label: 'Scadenza', color: '#ef4444' },
  campaign: { label: 'Follow-up', color: '#0ea5e9' },
  conversation: { label: 'Email', color: '#22c55e' },
  send_queue: { label: 'Invio fallito', color: '#dc2626' },
  inbound: { label: 'Email orfana', color: '#f97316' },
  quotation: { label: 'Preventivo', color: '#b45309' },
  ai_draft: { label: 'Bozza AI', color: '#8b5cf6' },
  call: { label: 'Richiamata', color: '#0891b2' },
  monitoring: { label: 'Monitoraggio', color: '#64748b' },
  warehouse: { label: 'DDT', color: '#a16207' },
  // F3.2 — tipi dell'Action Center unificati nel motore server (dash-agenda)
  noemail: { label: 'Email mancante', color: '#e11d48' },
  bounce: { label: 'Bounce', color: '#be123c' },
  stalled: { label: 'Fornitore fermo', color: '#7c3aed' },
  dormant: { label: 'Dormiente', color: '#475569' },
  conflict: { label: 'Conflitto dati', color: '#94a3b8' },
};

// Icona per tipo di azione (card "Da fare adesso") — copia 1:1 del v1.
export const ACT_ICON = {
  send_failed: '✉', send_failed_db: '⚠', inbound_unmatched: '❓', quotation_expired: '⏱',
  ai_draft_pending: '🤖', callback_due: '📞', monitoring_due: '📈', ddt_draft: '📄',
  task_due: '☐', scadenza_fiscale: '⚖', follow_up: '↻', reply_needed: '✉',
  // F3.2 — Action Center unificato
  email_missing: '@', email_bounced: '↩', supplier_stalled: '⏸',
  conversation_dormant: '💤', data_conflict: '≠',
};

// Gruppi urgenza della card (rosso/ambra/blu, 'later' resta all'agenda) — 1:1 col v1.
export const URG_GROUPS = [
  { key: 'overdue', label: 'In ritardo', color: '#dc2626', bg: '#fef2f2', border: '#fecaca' },
  { key: 'today', label: 'Oggi', color: '#b45309', bg: '#fffbeb', border: '#fde68a' },
  { key: 'week', label: 'Entro 7 giorni', color: '#1d4ed8', bg: '#eff6ff', border: '#bfdbfe' },
];

// KPI: [campo, etichetta] nello STESSO ordine del v1 (dashboard-module.js:295-301).
export const KPI_DEFS = [
  ['tasks_open', 'Task aperte'],
  ['deadlines_7d', 'Scadenze ≤ 7 giorni'],
  ['conversations_open', 'Conversazioni aperte'],
  ['suppliers_active', 'Fornitori attivi'],
  ['campaigns', 'Campagne'],
];

// Righe mostrate per gruppo urgenza prima di "Mostra altre…" (v1: ACT_PREVIEW=8).
export const ACT_PREVIEW = 8;

// Sezioni navigabili dal sottomenù shell (stessa mappa concettuale di
// __dashShellNav del v1 / DASH_NAV dell'adapter dash-v2).
export const SECTION_IDS = ['kpi', 'calendar', 'agenda', 'tasks'];
